// Client.onopen = openHandler
// Client.onerror = errorHandler
// Client.onclose = closeHandler

const SOCKET_URI = 'im.pcbcart.com'
const SOCKET_PORT = 8443
const SOCKET_IDENT = 'cmd'
const SOCKET_SECURE = true
window.CHAT_SOCKET_STATUS  = ''

const openHandler = (v) => {
    window.CHAT_SOCKET_STATUS = 'open'
}

const closeHandler = (v) => {
    window.CHAT_SOCKET_STATUS = 'close'
}

const errorHandler = (v) => {
    window.CHAT_SOCKET_STATUS = 'error'
}

const socket = (context) => {
    return {
        host: SOCKET_URI,
        port: SOCKET_PORT,
        identifier: SOCKET_IDENT,
        secure: SOCKET_SECURE,
        openHandler: openHandler,
        closeHandler: closeHandler,
        errorHandler: errorHandler
    }
}

export default socket


// WEBPACK FOOTER //
// ./src/socket.js